
export const root = {
    background: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    height: '1.5rem'
};

export const value = {
    background: '{primary.color}'
};

export const label = {
    color: '{primary.contrast.color}',
    fontSize: '0.875rem',
    fontWeight: '600'
};

export default {
    root,
    value,
    label
};
